import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AttorneySection from "../../Components/HomeSections/AttorneySection";
import PageBanner from "../../layout/Banner";
import { Helmet } from "react-helmet";

const OurTeam = () => {
  return (
    <>
      <Helmet>
        <title>Our Team - R & P Law Partners Chambers</title>
        <meta
          name="description"
          content="Meet the expert legal team at R & P Law Partners Chambers. Experienced lawyers dedicated to providing trusted legal solutions  and client success."
        />
        <meta
          name="keywords"
          content="R & P Law Partners, Law Firm, Lawyers, Legal Team, Legal Experts, Attorneys"
        />
        <noscript>
          Please enable JavaScript to view this page properly.
        </noscript>
      </Helmet>
      <Header />
      <PageBanner
        title="Our Team"
        subtitle="Meet the legal minds behind our success"
      />
      <AttorneySection />
      <Footer />
    </>
  );
};

export default OurTeam;
